export default "__VITE_ASSET__CHXAnKUz__"